import { ValueSuggestType } from '../../../common/base-search-result/base-search-result.helpers';
import { SEARCH_EVENT_TYPE } from '../../../common/search/search.constants';
import { world } from '../../../languages';
import qualityEventsHelpers from '../quality-events.helpers';

export const SRCH_QUALITY_EVENTS = {
    valueSuggest({ query, suggest, type }: ValueSuggestType) {
        qualityEventsHelpers.track({
            query,
            type: 'valueSuggest',
            extra: JSON.stringify({ suggest, type })
        });
    },
    clearSearchField(onFinally?: () => void) {
        qualityEventsHelpers.track({ type: SEARCH_EVENT_TYPE.CLEAR_SEARCH_FIELD }).finally(onFinally);
    },
    viewSearchResults(viewType: string) {
        qualityEventsHelpers.track({
            extra: `${viewType}View`,
            type: 'viewSearchResults'
        });
    },
    emptyResultPage() {
        qualityEventsHelpers.track({
            type: 'emptyResultPage'
        });
    },
    noResultsScreenShown(suggest?: string) {
        qualityEventsHelpers.track({
            type: 'noResultsScreenShown',
            extra: suggest ? JSON.stringify({ suggest }) : undefined
        });
    },
    apearedInSearch(
        query: string,
        isSchoolsPage: boolean,
        initMaterials: { index: number; material_id: number; price: Price }[]
    ) {
        qualityEventsHelpers.track({
            type: 'appearedInSearch',
            query,
            source: isSchoolsPage ? 'navigation' : 'search',
            extra: JSON.stringify(initMaterials)
        });
    },
    totalSearchResults(total: number) {
        qualityEventsHelpers.trackPostponed({
            total_results: total
        });
    },
    suggestionSearch(query: string, value: string, type: string) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                value: query,
                typedValue: value,
                type,
                world
            }),
            type: SEARCH_EVENT_TYPE.SUGGESTION_SEARCH
        });
    },
    searchEvent(extra: string, source: string, query: string, type: string) {
        qualityEventsHelpers.track({
            extra,
            source,
            query,
            type
        });
    }
};
